(() => {
  const root = document.body;
  if (!root || root.dataset.rfPriceTest !== 'true') return;

  const storageKey = root.dataset.rfPriceTestStorageKey;
  const variants = {
    a: root.dataset.rfPriceTestAId,
    b: root.dataset.rfPriceTestBId,
  };
  const prices = {
    a: root.dataset.rfPriceTestAPrice,
    b: root.dataset.rfPriceTestBPrice,
  };
  const knownVariantIds = new Set([
    root.dataset.rfPriceTestControlId,
    variants.a,
    variants.b,
    ...(root.dataset.rfPriceTestSourceIds || '').split(',').filter(Boolean),
  ]);

  const requestedGroup = new URLSearchParams(window.location.search).get('price_test');
  let group = requestedGroup === 'a' || requestedGroup === 'b' ? requestedGroup : null;

  if (!group) {
    try {
      const storedGroup = window.localStorage.getItem(storageKey);
      if (storedGroup === 'a' || storedGroup === 'b') group = storedGroup;
    } catch (_) {}
  }

  if (!group) group = Math.random() < 0.5 ? 'a' : 'b';

  try {
    window.localStorage.setItem(storageKey, group);
  } catch (_) {}
  document.cookie = `${storageKey}=${group}; Max-Age=2592000; Path=/; SameSite=Lax`;

  const variantId = variants[group];
  const price = prices[group];
  const marker = group === 'a' ? root.dataset.rfPriceTestAMarker : root.dataset.rfPriceTestBMarker;
  root.dataset.productVariantId = variantId;
  root.dataset.rfPriceTestGroup = group;

  function prepareForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || !knownVariantIds.has(String(idInput.value))) return;

    idInput.value = variantId;
    let markerInput = form.querySelector('input[name="properties[_price_test_group]"]');
    if (!markerInput) {
      markerInput = document.createElement('input');
      markerInput.type = 'hidden';
      markerInput.name = 'properties[_price_test_group]';
      form.appendChild(markerInput);
    }
    markerInput.value = marker;
  }

  function applyExperiment(scope = document) {
    scope.querySelectorAll('.bh-price-new, .bprc-sale').forEach((element) => {
      element.textContent = price;
    });
    scope.querySelectorAll(`product-price[data-product-id="${root.dataset.rfPriceTestProductId}"] .price`).forEach((element) => {
      element.textContent = price;
    });
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(prepareForm);
  }

  applyExperiment();
  root.classList.add('rf-price-test-ready');

  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) prepareForm(event.target);
  }, true);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) applyExperiment(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
